import React from 'react'
import { CircularProgress, TableBody, TableCell, TableRow } from '@material-ui/core'
import { Order } from '.'
import { processCommission } from './util/processCommissions'

interface Props {
  users: any[]
  isNumeric?: boolean
  order?: Order
  orderBy?: string
  rowsPerPage: number
  page: number
  isDateSort?: boolean
  isLoading: boolean
  isTeam: boolean
}

const TrackingBody: React.FC<Props> = ({ users, isLoading, rowsPerPage, page }) => {
  const currencyFormat = (num: number) => {
    const round = Math.round(num)
    return `$ ${round.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')}`
  }
  if (isLoading)
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '60vh',
          width: '100vw'
        }}
      >
        <CircularProgress style={{ color: '#ff6900' }} />
      </div>
    )
  return (
    <>
      <TableBody>
        {users.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map(user => {
          const { commission, prepayment, total } = processCommission(user)
          return (
            <TableRow className="table-row--container" key={user._id}>
              <TableCell align="left">{user.name}</TableCell>
              <TableCell align="center">{user.stages.office}</TableCell>
              <TableCell align="center">{user.stages.success}</TableCell>
              <TableCell align="center">{user.payments.find((a: any) => a.index === 1)?.datePaid}</TableCell>
              <TableCell align="center">{currencyFormat(user.stages.fee / 1.19)}</TableCell>
              <TableCell align="center">{currencyFormat(user.stages.payments)}</TableCell>
              <TableCell align="center">{commission.percentage || '-'}</TableCell>
              <TableCell align="center">{commission.promotionPercentage || '-'}</TableCell>
              <TableCell align="center">{currencyFormat(prepayment || 0)}</TableCell>
              <TableCell align="center">{commission.amount ? currencyFormat(commission.amount) : '-'}</TableCell>
              <TableCell align="center">
                {commission.promotionAmount ? currencyFormat(commission.promotionAmount) : '-'}
              </TableCell>
              <TableCell align="center">{currencyFormat(total)}</TableCell>
            </TableRow>
          )
        })}
      </TableBody>
    </>
  )
}

export default TrackingBody
